import { useState } from 'react';
// @mui
import {
  Container,
  Stack,
  Typography,
  Pagination,
  Box,
  IconButton,
  Tooltip,
  Grid,
} from '@mui/material';
// layouts
import Layout from '../../layouts';
// hooks
import useAuth from '../../hooks/useAuth';
import useResponsive from '../../hooks/useResponsive';
// guards
import RegisterGuard from '../../guards/RegisterGuard';
import NickNameGuard from '../../guards/NickNameGuard';
import EmptyProfileGuard from '../../guards/EmptyProfileGuard';
// components
import Page from '../../components/Page';
import SvgIconStyle from '../../components/SvgIconStyle';
import Iconify from '../../components/Iconify';
import {
  ScoreCard,
  MatchingCard,
  MatchingStatusTooltip,
  MatchingTipDialog,
  RewardCards,
} from '../../sections/dashboard/crew';
// swr
import useSWR from 'swr';
// utils
import axiosSWRFetcher from '../../utils/swrFetcher';


DashboardCrew.getLayout = function getLayout(page) {
  return <Layout variant="nav">{page}</Layout>
}

// -------------------------------------------------------
export default function DashboardCrew() {
  const { user } = useAuth();
  const smUp = useResponsive('up', 'sm');
  const [openMatchingTipDialog, setOpenMatchingTipDialog] = useState(false);

  const [page, setPage] = useState(1);

  const { data: offerResponse, isLoading: isOfferLoading } = useSWR(user ? `/api/crews/offers/?page=${page}` : null, axiosSWRFetcher, {errorRetryInterval: 2000, revalidateOnMount: true});
  const { data: scoreResponse, isLoading: isScoreLoading } = useSWR(user ? `/api/crews/score/` : null, axiosSWRFetcher, {errorRetryInterval: 2000, revalidateOnMount: true});
  const offers = offerResponse?.results || [];
  const pageCount = offerResponse?.page_count || 0;
  const availableHour = user?.crew?.limit_working_hours_per_week - user?.crew?.current_working_hours_per_week - user?.crew?.matching_working_hours_per_week;

  const handlePagination = (event, value) => {
    setPage(value);
  }

  return (
    <RegisterGuard>
      <NickNameGuard>
      <EmptyProfileGuard>
      <Page title="크루">
        <Container maxWidth="laptop">
          <Typography variant="h4" sx={{ mb: 4 }}>
            사이드잡 매칭
          </Typography>
          {/* DIO Score */}
          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1.5 }}>
            <SvgIconStyle src={`/icons/dio-score.svg`} sx={{ width: 86, height: 24 }} />
            <Typography variant="caption" sx={{ color: "text.disabled" }}>
              최근 6개월 • 동일 포지션
            </Typography>
            <Tooltip title="매칭 팁 보기">
              <IconButton size="small" onClick={() => setOpenMatchingTipDialog(true)}>
                <Iconify icon="eva:info-fill" sx={{ color: "text.secondary" }} />
              </IconButton>
            </Tooltip>
          </Stack>

          {/* score cards */}
          <ScoreCard score={scoreResponse} isLoading={isScoreLoading} />

          {/* spacing */}
          <Box sx={{ pt: { xs: 1, sm: 3 } }} />

          <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2 }}>
            <Typography variant="subtitle1">
              매칭 진행 상황
            </Typography>
            <MatchingStatusTooltip
              matchAllowed={user?.crew?.is_matching_allowed}
              availableHour={availableHour}
            />
          </Stack>
          <Grid container spacing={2} rowGap={3}>
            <Grid item xs={12} md={8}>
              <MatchingCard offers={offers} isLoading={isOfferLoading} />
              {pageCount > 1 && (
              <Stack sx={{ width: 1 }} justifyContent={"center"} alignItems={"center"}>
                <Pagination size={smUp ? "medium" : "small"} sx={{ mt: 3 }} count={pageCount} page={page} onChange={handlePagination} shape="rounded" />
              </Stack>
              )}
            </Grid>
            <Grid item xs={12} md={4}>
              <RewardCards />
            </Grid>
          </Grid>
        </Container>

        <MatchingTipDialog
          open={openMatchingTipDialog}
          closeDialog={() => setOpenMatchingTipDialog(false)}
        />
      </Page>
      </EmptyProfileGuard>
      </NickNameGuard>
    </RegisterGuard>
  )
}
